const routes = [
  {
    path: 'login',
    name: 'login',
    component: () => import(/* webpackChunkName: "login" */ '@/view/authentication/SignIn.vue'),
    meta: { title : 'Sign-in' }
  },
  {
    path: 'register',
    name: 'register',
    component: () => import(/* webpackChunkName: "register" */ '@/view/authentication/Signup.vue'),
  },
  {
    path: 'forgotPassword',
    name: 'forgotPassword',
    component: () => import(/* webpackChunkName: "forgotPassword" */ '@/view/authentication/ForgotPassword.vue'),
  },
  {
    name: 'confirm-email',
    path: 'confirm-email/:token',
    component: () => import(/* webpackChunkName: "login" */ '@/view/authentication/ConfirmEmail.vue'),
  }
];

export default routes;
